<template>
  <a-modal
    title="审核"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            showSearch
            allow-clear
            v-decorator="['refund_address_id', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
            placeholder="请输入名称"
            :filter-option="false"
            :not-found-content="consumables_fetching ? undefined : null"
            @search="consumablesSearch"
            @change="handleConsumablesDataChange"
          >
            <a-spin v-if="consumables_fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in consumablesList" :key="d.id" :value="d.id">
              {{ d.address_detail }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            @change="handleSelectChange"
            v-decorator="['examine', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          >
            <a-select-option
              v-for="(val, key) in this.$Dictionaries.refund_order_exam_status"
              :key="key"
              :value="key">
              {{ val }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
import { refundAddressList } from '@/api/applet_shopmall_order'
export default {
  name: 'RefundExamineCreate',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      fetching: false,
      consumables_fetching: false,
      wmsGoodsList: [],
      consumablesList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.model)
    })
    this.fetchConsumablesData(undefined)
  },
  methods: {
    fetchConsumablesData (value) {
      this.consumables_fetching = true
      refundAddressList({ address_detail: value }).then(({ data }) => {
        this.consumablesList = data.entries || []
        this.consumables_fetching = false
      })
    },
    handleConsumablesDataChange (value) {
      console.log(value)
    },
    consumablesSearch (value) {
      if (value !== undefined) {
        this.fetchConsumablesData(value)
      }
    },
    loadEditInfo (data) {
      const { form } = this
      const formData = pick(data, ['consumables', 'unit'])
      this.id = formData.id
      form.setFieldsValue(formData)
      this.loading = false
    },
    handleSelectChange (value) {
      this.select_status_data = value
      console.log(this.select_status_data, typeof this.select_status_data)
    }
  }
}
</script>
